import React from 'react';
import ReactDOM from 'react-dom';
import { initApp } from '@meronex/app';
import { toast } from 'react-toastify';

(async () => {
  const App = await initApp({
    disableServer: true,
    disableUserAccount: true,
    disablePulseIndicator: true,
    toastPosition: toast.POSITION.TOP_CENTER,
  });

  // imported async after the app is loaded
  const IndexContainer = require('@meronex/components').IndexContainer;
  const AppRoutes = require('@meronex/layout').AppRoutes;

  const theme = require('./theme').default;
  const config = require('./config').config;

  const routes = require('./config/routes').routes;

  document.getElementById('loader').remove();

  const renderIndex = () => {
    return (
      <IndexContainer App={App} theme={theme} config={config}>
        <AppRoutes routes={routes} />
      </IndexContainer>
    );
  };
  ReactDOM.render(renderIndex(), document.querySelector('#root'));
})();
